import { ImportProductsXlsxTranslation } from "#i18n/translations/pt-BR/place/products/import-products-xlsx";

export const IMPORT_PRODUCTS_XLSX_ES_MX: ImportProductsXlsxTranslation = {
	header: {
		title: "Importar productos",
		bulkEditTitle: "Editar productos en masa",
	},
	layout: {
		importProductsTable: "Importar tu tabla de productos",
		tutorial: "Agrega uno o más productos a la vez importando una hoja de cálculo.",
		bulkEditTutorial:
			"Edita uno o más productos a la vez a través de la hoja de cálculo.",
	},
	form: {
		totalProducts: "Total de productos",
		successfullyImported: "Productos importados",
		productsWithErrors: "Productos con errores",
		alert: {
			title: "Productos con errores",
			message:
				"Identificamos algunos productos con información incorrecta. Descarga la hoja de cálculo con errores, corrige los datos y luego importa nuevamente.",
		},
		tooltip: {
			totalProducts: "Tu tabla tenía {{totalProducts}} productos",
			successfullyImported: "{{totalProducts}} productos ya han sido agregados con éxito",
			productsWithErrors: "Descarga la hoja de cálculo con errores y vuelve a subirla",
		},
		warning: {
			title: "Advertencia",
			description:
				"Los valores de los productos se ingresan en centavos, ex: 123 equivale a $1.23",
		},
		importProductsActiveByDefault: "Importar productos con el status activo",
	},
	sheet: {
		columns: {
			name: "Producto",
			systemProductId: "ID del Producto del Sistema",
			category: "Categoría",
			menuCategory: "Categoría del menú",
			description: "Descripción",
			image: "Imagen (ID)",
			imagePreview: "Imagen (visualización)",
			imageIndex: "Imagen (índice)",
			existingImage: "Imagen original",
			basicStorageUnit: "Unidad de medida",
			price: "Precio",
			priceInCents: "Precio en centavos",
			bars: "Bares (separados por punto y coma)",
			hasAlcohol: "¿Contiene alcohol?",
			isHiddenFromApp: "No mostrar el producto en la aplicación ZigApp",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - NCM",
			fiscalCest: "Fiscal - CEST",
			fiscalProductGroup: "Fiscal - Grupo fiscal",
			fiscalProfile: "Fiscal - Perfil fiscal",
			fiscalIcmsBaseCalculoRetSt:
				"Fiscal - Base de cálculo del ICMS retenido en la operación anterior",
			fiscalIcmsValorSubistituto: "Fiscal - Valor del ICMS propio del sustituto",
			fiscalIcmsAliquotaFinal: "Fiscal - Alícuota soportada por el consumidor final",
			isStockable: "Stockable",
			beerBrand: "Marca de la cerveza",
			beerStyle: "Estilo de la cerveza",
			beerAbv: "ABV - Tasa de alcohol",
		},
		sampleFileName: "ejemplo_importacion_productos",
		errorFileName: "importacion_productos_con_errores",
		auxiliarSheets: {
			bars: "Bares",
			images: {
				ptBr: "PT-BR",
				esMx: "ES-MX",
				id: "ID",
				url: "URL",
				name: "Imágenes",
			},
		},
	},
	upload: {
		warning: {
			title: "Advertencia",
			description:
				"Utiliza únicamente la hoja descargada de este place. Las hojas exportadas de otros places no son aceptadas.",
		},
	},
	button: {
		continue: "Continuar Importación",
		validating: "Validando...",
		cancel: "Cancelar",
	},
};
